import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { faBell, faCalendarAlt, faComment, faTimes } from '@fortawesome/free-solid-svg-icons';
import { CalendarEvent } from 'angular-calendar';
import { Student } from 'backend/interfaces/student.interface';
import { Location } from 'backend/interfaces/location.interface';
import { AuthService } from '../auth/auth.service';
import { AppointmentService } from '../services/appointment.service';

import { StudentService } from './services/student.service';
import { SideNavService, SidenavActions } from './services/side-nav.service';
import { LocationService } from './services/location.service';
import { PractitionerService } from './services/practitioner.service';
import { DOCUMENT } from '@angular/common';
import { DataService } from '../services/data.service';
import * as moment from 'moment';
import { ServicesService } from './services/services.service';
import { Service } from 'backend/interfaces/service.interface';
import { ParentService } from './services/parent.service';
import { MealPlanService } from './services/meal-plan.service';
import { MealService } from './services/meal.service';
import { GroupService } from './services/group.service';
import { ChatService } from '../services/chat.service';
import { BusinessService } from './services/business.service';
import { BusinessStatus } from 'backend/enum/BusinessStatus.enum';
import { NotifyService } from '../services/notify.service';
import { AdminService } from './services/admin.service';
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class AdminComponent implements OnInit, AfterViewInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('chatDrawer') chatDrawer: MatSidenav;
  faTimes = faTimes;
  faBell = faBell;
  faCalendar = faCalendarAlt;
  currentUser = '';
  chatId = '';
  faChat = faComment;
  sideNavActions = SidenavActions;
  businessRequests = [];
  showChat;
  hasbackdrop = false;
  constructor(private businessService: BusinessService, private authService: AuthService, public sidenavService: SideNavService, private router: Router, private ar: ActivatedRoute, private studentService: StudentService, private groupService: GroupService, private appointmentService: AppointmentService, private locationService: LocationService, private practitionerService: PractitionerService, private dataService: DataService, private mealService: MealService, private mealPlanService: MealPlanService, private servicesService: ServicesService, private chatService: ChatService, private notifyService: NotifyService, private adminService: AdminService) { 
    authService.$User.subscribe((res)=>{
      if(res){
        this.currentUser = res.get('username');
        this.chatId = res.get('chatId');
      }
    })
  }
  date = new Date();
  async ngOnInit(): Promise<void> {
    this.notifyService.subscribeToNotifications();
    this.chatService.showChat$.subscribe(res => this.showChat = res);
    // this.studentService.getBirthdays(moment(this.date).format('MMM'));
    // this.parentService.getParentBirthdays(moment(this.date).format('MMM'));
    this.businessService.getBusinessCount();
    this.businessService.getBusinesses(10, 0);
    this.adminService.getUsers(10, 0);
    this.adminService.getUserCount();
    this.adminService.getAdCount();
    // this.studentService.getStudentCount();
    // this.studentService.getStudents(10, 0);
    // this.mealService.getMeals();
    // this.mealService.getMealCount();
    // this.mealPlanService.getMealPlans();
    // this.mealPlanService.getMealPlanCount();
    // this.dataService.getPractitioners();
    // this.dataService.getServices();
    // this.dataService.getLocations();
    this.groupService.getGroupCount();
    this.groupService.getAllGroups(300, 0);
    this.groupService.getGroups(10, 0);
    
    this.businessRequests = [];
    // this.appointmentService.getAppointmentsByLocation(null);
    this.businessService.getBusinessRequests(BusinessStatus.CREATED);
    this.appointmentService.appointmentRequests$.subscribe(r => this.businessRequests = r)
  }
  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }

  logout(){
    this.authService.signOut();
  }

  close(reason: string) {
    this.sidenav.close();
  }

  async loadProfile(e: Student): Promise<void>{
    this.router.navigate(['admin', 'parent', e.ID]);
  }

  async loadStudentProfile(e: Student): Promise<void>{
    this.router.navigate(['admin', 'student', e.ID]);
    this.sidenavService.close();
  }

  async loadLocation(e: Location): Promise<void>{
    this.router.navigate(['admin', 'location', e.name]);
  }

  async loadService(e: Service): Promise<void>{
    this.router.navigate(['admin', 'service', e.id]);
  }

  openAppointment(appointmentId: any){
    this.router.navigate(['admin', 'appointment', appointmentId]);
    this.sidenavService.close();
  }


  reviewAppointmentRequest(appointmentRequest: any): void {
    this.openSideNav(appointmentRequest);
    this.sidenavService.open(this.sideNavActions.ReviewAppointment);
  }

  openSideNav(e: CalendarEvent): void {
    this.appointmentService.setAppointment(e);
    this.sidenavService.open(this.sideNavActions.UpdateAppointment);
  }

  website(): void{
    this.router.navigate(['admin','dashboard']);
  }

  toggleChat(){
    this.chatService.showChat.next(!this.showChat);
  }

}
